import SunmiPrintJobRepository from '../../../components/repository/SunmiPrintJobRepository';
import BasePrintService from './BasePrintService';

class SunmiPrintService extends BasePrintService {
    constructor(app) {
        super(app)
        window.SunmiPrintService = this
    }
    getPrintJobRepository = () => {
        return SunmiPrintJobRepository.getInstance()
    }

    customProcessPrintJob(printJob) {
        if (printJob.printer_type === this.printerType.PRINTER_TYPE_SUNMI) {
            this._sendToFlutterPrint(printJob, {
                printer_type: 'sunmi',
            })
            return true
        }
        // Override this function to define your own logic
        return false
    }
}

export default new SunmiPrintService();